<template>
  <div v-if="premiumTrial.enabled" class="promo-top-bar">
    <div class="container-site promo-top-bar-inner">
      <span class="promo-top-bar-badge">{{ premiumTrial.badge }}</span>
      <p class="promo-top-bar-text">
        {{ premiumTrial.headline }}
      </p>
      <RouterLink :to="premiumTrial.ctaTo" class="promo-top-bar-cta">
        {{ premiumTrial.ctaLabel }}
        <svg class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
        </svg>
      </RouterLink>
    </div>
  </div>
</template>

<script setup>
import { RouterLink } from 'vue-router'
import { premiumTrial } from '@/config/site'
</script>
